import AddCircleIcon from "@mui/icons-material/AddCircle";
import { Box, Button, TableCell, Typography } from "@mui/material";
import React from "react";

import SubGrowerAPI from "../api/SubGrower.api";
import BasicCreateModal from "../components/BasicCreateModal";
import Layout from "../components/Layout";
import ListModel from "../components/ListModel";
import { Subgrower, TableColumn } from "../types";
import { extractDate } from "../utils";

const columns: TableColumn<Subgrower>[] = [
  { field: "name", label: "Name" },
  { field: "createdAt", label: "Created At Date" },
];

function buildTableRow(subGrower: Subgrower): JSX.Element[] {
  return [
    <TableCell key={"name"}>{subGrower.name}</TableCell>,
    <TableCell key={"createdAt"}>{extractDate(subGrower.createdAt)}</TableCell>,
  ];
}

export default function SubGrowerList() {
  const [openModel, setOpenModal] = React.useState<boolean>(false);
  return (
    <Layout>
      <Box
        sx={{
          display: "flex",
          flexGrow: 1,
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h2">SubGrowers</Typography>
          <Button onClick={() => setOpenModal(true)}>
            <AddCircleIcon />
          </Button>
        </Box>

        <ListModel
          defaultOrderBy={"name"}
          modelApiUseList={SubGrowerAPI.useList}
          modelBaseUrl={"sub_growers"}
          columns={columns}
          buildTableRow={buildTableRow}
        />

        <BasicCreateModal
          open={openModel}
          onClose={() => setOpenModal(false)}
          modelApiUseSave={SubGrowerAPI.useSave}
          navigateUrl="/sub_growers"
        />
      </Box>
    </Layout>
  );
}
